// =============================================================================
// web/shims/react-native-documents-picker.js — WEB shim for
// @react-native-documents/picker.
//
// The native document picker has no web equivalent wired yet. Resolves as a clean
// cancellation so callers (ChannelScreen / DMScreen attachment flows) no-op on web
// instead of crashing the bundle. Native iOS resolves the real package untouched.
// =============================================================================
export const errorCodes = {
  OPERATION_CANCELED: 'DOCUMENT_PICKER_CANCELED',
};

export function isErrorWithCode() {
  return false;
}

export async function pick() {
  const err = new Error('Document picking is not available on the web build of CRYB.');
  err.code = errorCodes.OPERATION_CANCELED;
  throw err;
}

export async function pickDirectory() {
  return null;
}

// keepLocalCopy: on native it copies a picked file into app storage. No picking
// on web, so this is a no-op that echoes back whatever it was given.
export async function keepLocalCopy(options) {
  const files = (options && options.files) || [];
  return files.map((f) => ({ status: 'success', localUri: f.uri }));
}

export const types = {
  allFiles: '*/*',
  images: 'image/*',
  pdf: 'application/pdf',
  audio: 'audio/*',
  video: 'video/*',
};

export default { pick, pickDirectory, keepLocalCopy, types, errorCodes, isErrorWithCode };
